import { render } from "./questions-modal.vue?vue&type=template&id=7ae4bb4d"
import script from "./questions-modal.vue?vue&type=script&lang=js"
export * from "./questions-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__